export default {
    methods: {
        notifyCheck() {
            let parent = this.$parent;
            if(parent && parent.$options.name == 'clLabel') {
                parent.checkProp();
            }
        }
    }
}
